export const monthStringToNumber = (month) => {
    let monthNumber = 1;
    switch (month) {
        case 'JANEIRO':
            monthNumber = 1
            break;
        case 'FEVEREIRO':
            monthNumber = 2
            break;
        case 'MARÇO':
            monthNumber = 3
            break;
        case 'ABRIL':
            monthNumber = 4
            break;
        case 'MAIO':
            monthNumber = 5
            break;
        case 'JUNHO':
            monthNumber = 6
            break;
        case 'JULHO':
            monthNumber = 7
            break;
        case 'AGOSTO':
            monthNumber = 8
            break;
        case 'SETEMBRO':
            monthNumber = 9
            break;
        case 'OUTUBRO':
            monthNumber = 10
            break;
        case 'NOVEMBRO':
            monthNumber = 11
            break;
        case 'DEZEMBRO':
            monthNumber = 12
            break;
    }
    return monthNumber;
};

export const monthNumberToString = (month) => {
    let monthString = 1;
    switch(month) {
        case 1:
            monthString = 'janeiro'
            break;
        case 2:
            monthString = 'fevereiro'
            break;
        case 3:
            monthString = 'março'
            break;
        case 4:
            monthString = 'abril'
            break;
        case 5:
            monthString = 'maio'
            break;
        case 6:
            monthString = 'junho'
            break;
        case 7:
            monthString = 'julho'
            break;
        case 8:
            monthString = 'agosto'
            break;
        case 9:
            monthString = 'setembro'
            break;
        case 10:
            monthString = 'outubro'
            break;
        case 11:
            monthString = 'novembro'
            break;
        case 12:
            monthString = 'dezembro'
            break;
    }
    return monthString;
};
